import { render, staticRenderFns } from "./WebsiteNavigationItemForm.vue?vue&type=template&id=3412a78c&scoped=true&"
import script from "./WebsiteNavigationItemForm.vue?vue&type=script&lang=js&"
export * from "./WebsiteNavigationItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3412a78c",
  null
  
)

export default component.exports